import React, { ComponentProps } from 'react';
import { ImageProps, ScrollView, View, useWindowDimensions } from 'react-native';
import { calcSizeForDevice, getResponsiveSize } from 'utils/index';
import { Platform } from 'utils/platform';

import FocusView from 'components/FocusView';
import HeroImage from 'components/Hero/HeroImage';
import { HeroHeaderProps, HeroProgramProps } from 'components/Hero/index';
import CarouselGradient from 'components/NewCarrousel/carouselGradient';

type RefHeroImage = ImageProps & HTMLElement;

// Mapeamento de tamanhos
const sizeMap = {
  sm: 14,
  '2xl': 24,
};

const ScrollComponent = ({ children }: ComponentProps<typeof View>) => {
  if (Platform.OS === 'web') return children;

  return <ScrollView>{children}</ScrollView>;
};

const HeroWeb: React.FC<HeroProgramProps> = ({ program, children, numItems = 0, renderItem }) => {
  const { width, height } = useWindowDimensions();
  const refImage = React.useRef<RefHeroImage>(null);
  const vstackSpaceForTv = Platform.isTV && width < 1920 ? 'sm' : '2xl';

  if (refImage.current) {
    const divElement = refImage.current.querySelector('div');
    divElement ? (divElement.style.backgroundPositionY = 'top') : null;
  }

  return (
    <FocusView>
      <View style={{ position: 'absolute', width: '100%', top: 0, left: 0, height, zIndex: -10 }}>
        <HeroImage
          program={program}
          title={program.title}
          source={program.imageBgHorizontal?.url! || program.imageHorizontal?.url!}
        />
        <CarouselGradient />
      </View>

      <ScrollComponent>
        <View
          style={{
            height: '100%',
            width: '100%',
            position: 'relative',
            paddingTop: calcSizeForDevice(150, 80),
            paddingHorizontal: calcSizeForDevice(64),
          }}>
          <View
            style={{
              width: '100%',
              justifyContent: 'space-around',
              zIndex: 1000,
              flexDirection: 'row',
            }}>
            <View style={{ width: '100%', gap: sizeMap[vstackSpaceForTv] || 0 }}>
              {children}
              {Array.from({ length: numItems }).map(() => renderItem?.())}
            </View>
          </View>
        </View>
      </ScrollComponent>
    </FocusView>
  );
};

const HeroHeaderWeb: React.FC<HeroHeaderProps> = ({ children, Aside }) => {
  const { width } = useWindowDimensions();
  const vstackSpaceForTv = Platform.isTV && width < 1920 ? 'sm' : '2xl';

  return (
    <View style={{ gap: sizeMap[vstackSpaceForTv] || 0, justifyContent: 'space-between' }}>
      <View style={{ flexDirection: 'row', gap: sizeMap[vstackSpaceForTv] || 0 }}>
        <View style={{ width: `${getResponsiveSize({ base: 50, xl: 40 })}%` }}>{children}</View>
        <View style={{ flexGrow: 1, alignItems: 'center', justifyContent: 'center' }}>{Aside}</View>
      </View>
    </View>
  );
};

export default Object.assign(HeroWeb, {
  Header: HeroHeaderWeb,
});
